import React from 'react';
import Text from '../../Text';

export interface InlinePageHeadingProps {
    heading: string;
}

export default function InlinePageHeading({ heading }: InlinePageHeadingProps) {
    return (
        <div className="inline-page-heading">
            <Text
                baseClass="heading"
                variations={['size5']}
                style={{ marginBottom: 20, marginTop: 30 }}
            >
                {heading}
            </Text>
        </div>
    );
}

InlinePageHeading.calculateMaxHeightPercentage = function (): number {
    return 0.125;
};
